import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  MOBILE_EXECUTIVE_DASHBOARD_PATH,
  PENDING_APPROVALS_PATH,
  hasEntityDashboardAccess,
  hasPendingApprovalsAccess,
} from "views/Dashboard/utils/dashboardAccess";

const MENU_ITEMS = [
  {
    label: "Pending Approvals",
    path: PENDING_APPROVALS_PATH,
    canAccess: hasPendingApprovalsAccess,
    isActive: (pathname) => pathname.startsWith(PENDING_APPROVALS_PATH),
  },
  {
    label: "Executive Dashboard",
    path: MOBILE_EXECUTIVE_DASHBOARD_PATH,
    canAccess: hasEntityDashboardAccess,
    isActive: (pathname) => pathname.startsWith(MOBILE_EXECUTIVE_DASHBOARD_PATH),
  },
];

const MobileManagerNavigation = ({ className = "" }) => {
  const user = useSelector((state) => state.auth?.user);
  const location = useLocation();
  const navigate = useNavigate();

  const accessibleItems = MENU_ITEMS.filter((item) => item.canAccess(user));

  if (accessibleItems.length === 0) return null;

  return (
    <nav
      className={`min-w-0 flex-1 md:hidden ${className}`}
      aria-label="Mobile workspace navigation"
    >
      <div
        role="tablist"
        aria-label="Available pages"
        className="flex w-full items-center gap-1 rounded-xl border border-[#E7DED5] bg-[#F7F5F2] p-1"
      >
        {accessibleItems.map((item) => {
          const isActive = item.isActive(location.pathname);

          return (
            <button
              key={item.path}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-current={isActive ? "page" : undefined}
              className={`min-w-0 flex-1 rounded-lg px-2 py-2 text-center text-[11px] font-bold leading-4 transition ${
                isActive
                  ? "bg-[#FD6600] text-white shadow-sm"
                  : "text-[#5E574E] hover:bg-white hover:text-[#C45100]"
              }`}
              onClick={() => {
                if (!isActive) navigate(item.path);
              }}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileManagerNavigation;
